import { useState, useEffect } from "react";
import Api from "../../utils/Api";
import { API_ROUTE_LIST_MEDIA_MAPPED } from "../../routes";

export default function useGetMappedBisList(auto = false, filters = {}) {
  const [mediaMappingList, setMediaMappingList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const getMappedBisList = (payload = {}, showLoader = true) => {
    setIsLoading(showLoader);

    const finalPayload = {
      includeMapped: true,
      ...payload,
    };

    return Api.post(API_ROUTE_LIST_MEDIA_MAPPED, finalPayload)
      .then((response) => {
        setMediaMappingList(
          Array.isArray(response?.data?.data) ? response.data.data : [],
        );
      })
      .catch((error) => {
        setMediaMappingList([]);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    if (auto) getMappedBisList(filters);
  }, [auto, JSON.stringify(filters)]);

  return {
    mediaMappingList,
    getMappedBisList,
    isLoading,
  };
}
